<template>
  <div class="luck-page">
    <!-- 顶部栏 -->
    <header class="top-nav">
      <button type="button" class="icon-btn" aria-label="Volver" @click="$router.go(-1)">
        <van-icon name="arrow-left" />
      </button>
      <h1 class="nav-title">{{ getLabel('luckdraw.title', 'Ruleta de la Suerte') }}</h1>
      <button type="button" class="icon-btn" aria-label="Cerrar" @click="$router.go(-1)">
        <van-icon name="cross" />
      </button>
    </header>

    <main class="page-shell">
      <!-- 转盘区 -->
      <section class="wheel-section">
        <div class="wheel-wrap">
          <div class="wheel">
            <div class="wheel-face" :style="faceStyle">
              <div class="wheel-number" v-for="(p, i) in prizes" :key="i"
                   :style="{ transform: `rotate(${i * 45}deg) translateY(-92px)` }">
                <span class="num">{{ p.value }}</span>
              </div>
            </div>
            <div class="wheel-pointer"></div>
            <div class="go-btn" :class="{ disabled: spinning || spinsLeft <= 0 }" @click="draw">
              GO
            </div>
          </div>

          <!-- 装饰 -->
          <div class="deco chest" aria-hidden="true">💰</div>
          <div class="deco coin" aria-hidden="true">🪙</div>
          <div class="deco gift" aria-hidden="true">🎁</div>
        </div>

        <div class="spins-pill">
          {{ getLabel('luckdraw.spinsLeft', 'Remaining spins') }}: <b>{{ spinsLeft }}</b>
        </div>
      </section>

      <!-- 邀请区 -->
      <section class="invite-card">
        <h2 class="invite-title">
          {{ getLabel('luckdraw.inviteTitle', 'Invite Friends, Earn Rewards') }}
        </h2>

        <div class="tabs">
          <button type="button" class="tab" :class="{ active: activeTab === 'winners' }"
                  @click="activeTab = 'winners'">
            {{ getLabel('luckdraw.winnerRecords', 'Registration of Winners') }}
          </button>
          <button type="button" class="tab" :class="{ active: activeTab === 'mine' }"
                  @click="activeTab = 'mine'">
            {{ getLabel('luckdraw.myPrizes', 'My Awards') }}
          </button>
        </div>

        <div class="record-list">
          <template v-if="activeTab === 'winners'">
            <div v-if="winners.length" class="scroll-wrap">
              <div class="scroll-inner" :class="{ scrolling: winners.length > visibleCount }">
                <div v-for="(w, i) in winnersScroll" :key="i" class="record-item">
                  <div class="record-left">
                    <div class="record-label">{{ getLabel('luckdraw.congrats', 'Congratulations') }}</div>
                    <div class="record-phone">{{ w.phone || w.type_text }}</div>
                  </div>
                  <div class="record-amount">+{{ w.amount }} INR</div>
                </div>
              </div>
            </div>
            <div v-if="winners.length === 0" class="empty">{{ getLabel('luckdraw.noData', 'No records') }}</div>
          </template>
          <template v-else>
            <div v-for="(w, i) in myPrizes" :key="i" class="record-item">
              <div class="record-left">
                <div class="record-label">{{ getLabel('luckdraw.congrats', 'Congratulations') }}</div>
                <div class="record-phone">{{ w.phone || w.type_text }}</div>
              </div>
              <div class="record-amount">+{{ w.amount }} INR</div>
            </div>
            <div v-if="myPrizes.length === 0" class="empty">{{ getLabel('luckdraw.noData', 'No records') }}</div>
          </template>
        </div>
      </section>

      <!-- 活动规则 -->
      <section class="rules-card">
        <h2 class="rules-title">{{ getLabel('luckdraw.rulesTitle', 'Event Rules') }}</h2>
        <ul class="rules-list">
          <li v-for="(rule, i) in rules" :key="i">{{ rule }}</li>
        </ul>
      </section>
    </main>
  </div>
</template>

<script>
import Vue from "vue";
import Fetch from "../../utils/fetch";
import { Icon, Toast } from "vant";

Vue.use(Icon);
Vue.use(Toast);

const PRIZES = [40, 80, 150, 300, 500, 1000, 3000, 5000];

export default {
    name: "luckDraw",
    data() {
        return {
            prizes: PRIZES.map((v) => ({ value: v })),
            spinsLeft: 0,
            winners: [],
            myPrizes: [],
            activeTab: "winners",
            spinning: false,
            prizeSynced: false,
            rotationDeg: 0,
            rules: [
                "This event is open to all users, new and existing.",
                "During the event, meeting the corresponding conditions grants you a spin opportunity. There is no limit on the number of spins.",
                "Spin opportunities are issued automatically by the system; enter the event page and tap [GO] to participate.",
                "Won rewards are automatically credited to your personal account balance.",
                "Draw results are randomly generated by the system; the entire process is open, transparent, fair and impartial.",
                "The platform reserves the final right of interpretation of this event.",
            ],
        };
    },
    computed: {
        faceStyle() {
            return {
                transform: `rotate(${this.rotationDeg}deg)`,
                transition: this.spinning ? "transform 4.5s cubic-bezier(0.15, 0.6, 0.15, 1)" : "none",
            };
        },
    },
    mounted() {
        this.fetchUserInfo();
        this.fetchPrizeList();
        this.fetchPrizeRecord();
        this.fetchMyPrize();
    },
    methods: {
        getLabel(key, fallback) {
            return this.$te(key) ? this.$t(key) : fallback;
        },
        // 抽奖机会 prize 在用户信息接口 /user/info 返回中
        fetchUserInfo() {
            Fetch("/user/info", {})
                .then((r) => {
                    const d = (r && r.data) || {};
                    this.spinsLeft = Math.max(0, Number(d.prize ?? 0));
                })
                .catch(() => {});
        },
        // 奖品列表：/api/user/prizeList（lc_prize 表：name1~8/money1~8/odds1~8/reason1~8/rule）
        fetchPrizeList() {
            Fetch("/user/prizeList", {})
                .then((r) => {
                    const raw = (r && r.data) || {};
                    const row = Array.isArray(raw) ? raw[0] : raw;
                    if (!row || typeof row !== "object") return;
                    const list = [];
                    for (let i = 1; i <= 8; i++) {
                        const money = Number(row["money" + i] ?? 0);
                        const name = String(row["name" + i] || "");
                        if (money > 0 || name) {
                            list.push({
                                name,
                                value: money,
                                odds: Number(row["odds" + i] ?? 0),
                                reason: String(row["reason" + i] || ""),
                            });
                        }
                    }
                    if (list.length) {
                        // 保持转盘 8 格（45°/格），不足的用初始金额补足
                        this.prizes = PRIZES.map((v, idx) => {
                            const item = list[idx];
                            return item
                                ? item
                                : { name: "", value: v, odds: 0, reason: "" };
                        });
                    }
                    if (row.rule) {
                        const arr = String(row.rule)
                            .split("\n")
                            .map((s) => s.trim())
                            .filter(Boolean);
                        if (arr.length) this.rules = arr;
                    }
                })
                .catch(() => {});
        },
        // 获奖记录：/api/user/prizeRecord.html（当前用户全部中奖历史，按时间倒序）
        fetchPrizeRecord() {
            Fetch("/user/prizeRecord.html", {})
                .then((r) => {
                    const raw = (r && r.data) || [];
                    const list = Array.isArray(raw) ? raw : raw.list || raw.records || [];
                    this.winners = list.map((w) => ({
                        phone: w.phone || w.mobile || "****0000",
                        amount: Number(w.amount ?? w.money ?? 0),
                        name: String(w.name || ""),
                        time: w.time || w.create_time || w.addtime || "",
                    }));
                })
                .catch(() => {});
        },
        // 我的奖品：/api/user/myPrize.html
        fetchMyPrize() {
            Fetch("/user/myPrize.html", {})
                .then((r) => {
                    const raw = (r && r.data) || [];
                    const list = Array.isArray(raw) ? raw : raw.list || raw.records || [];
                    this.myPrizes = list.map((w) => ({
                        phone: w.phone || w.mobile || "",
                        amount: Number(w.amount ?? w.money ?? 0),
                        name: String(w.name || ""),
                        time: w.time || w.create_time || w.addtime || "",
                    }));
                })
                .catch(() => {});
        },
        // 抽奖：/api/user/draw（Fetch 自动拼接 /api 前缀）
        draw() {
            if (this.spinning) return;
            if (this.spinsLeft <= 0) {
                Toast(this.getLabel("luckdraw.noSpins", "You have no spins left"));
                return;
            }
            this.spinning = true;
            this.prizeSynced = false;
            Fetch("/user/draw", {})
                .then((r) => {
                    const d = (r && r.data) || {};
                    // 抽奖后剩余机会以后端返回的 prize 为准
                    if (d.prize !== undefined && d.prize !== null) {
                        this.spinsLeft = Math.max(0, Number(d.prize));
                        this.prizeSynced = true;
                    }
                    if (Array.isArray(d.winners)) {
                        this.winners = d.winners.map((w) => ({
                            phone: w.phone || w.mobile || "****0000",
                            amount: Number(w.amount ?? w.money ?? 0),
                        }));
                    }
                    if (Array.isArray(d.my_prizes)) {
                        this.myPrizes = d.my_prizes.map((w) => ({
                            phone: w.phone || w.mobile || "",
                            amount: Number(w.amount ?? w.money ?? 0),
                        }));
                    }
                    // 以后端返回为准：优先 index（1 基奖品序号 name1~8 转 0 基，兼容 0 基）；
                    // 后端无 index 时（返回 name/money）用金额匹配对应格子
                    const idx = Number(d.index ?? d.prize_index ?? d.idx ?? -1);
                    let target = -1;
                    if (idx >= 1 && idx <= this.prizes.length) {
                        target = idx - 1;
                    } else if (idx >= 0 && idx < this.prizes.length) {
                        target = idx;
                    } else {
                        const money = Number(d.money ?? d.amount ?? -1);
                        const found = this.prizes.findIndex((p) => p.value === money);
                        target = found >= 0 ? found : Math.floor(Math.random() * this.prizes.length);
                    }
                    // 金额以后端返回的 money/amount 为准（缺省时用对应格子金额）
                    const prizeAmt =
                        d.money != null ? Number(d.money) : d.amount != null ? Number(d.amount) : null;
                    this.spinTo(target, prizeAmt);
                })
                .catch(() => {
                    this.spinning = false;
                });
        },
        spinTo(index, amount) {
            // 每格 45°，指针在正上方；顺时针旋转 5 圈后落到目标格中心
            const seg = 360 / this.prizes.length;
            const base = 360 * 5;
            // 当前已旋转角度取模，避免累加过大
            const currentMod = ((this.rotationDeg % 360) + 360) % 360;
            // 需要让第 index 格中心停在顶部：当前旋转 + 新旋转 ≡ -index*seg (mod 360)
            const targetMod = ((-index * seg) % 360 + 360) % 360;
            let delta = targetMod - currentMod;
            if (delta <= 0) delta += 360;
            this.rotationDeg += base + delta;

            setTimeout(() => {
                this.spinning = false;
                if (!this.prizeSynced) {
                    this.spinsLeft = Math.max(0, this.spinsLeft - 1);
                }
                // 抽奖后重新拉取用户信息，校准剩余抽奖机会
                this.fetchUserInfo();
                const prizeAmt = amount != null ? Number(amount) : this.prizes[index].value;
                Toast(`${this.getLabel("luckdraw.congrats", "Congratulations")}! +${prizeAmt} INR`);
            }, 4600);
        },
    },
};
</script>

<style lang="less" scoped>
.luck-page {
  min-height: 100vh;
  background: #05070f;
  color: #fff;
}

.top-nav {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 56px;
  padding: 0 14px;
}

.icon-btn {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 34px;
  height: 34px;
  padding: 0;
  border: 1px solid rgba(90, 130, 200, 0.3);
  border-radius: 50%;
  background: rgba(20, 35, 65, 0.6);
  color: #cdd8ee;
  display: grid;
  place-items: center;
  cursor: pointer;
}
.icon-btn:first-child { left: 0; }
.icon-btn:last-child { right: 0; }
.icon-btn .van-icon { font-size: 18px; }

.nav-title {
  margin: 0;
  font-size: 18px;
  font-weight: 700;
  color: #eef3ff;
}

.page-shell {
  width: 100%;
  max-width: 430px;
  min-height: 100vh;
  margin: 0 auto;
  padding: 0 14px 40px;
  box-sizing: border-box;
}

/* ---- 转盘区 ---- */
.wheel-section {
  position: relative;
  padding: 10px 0 20px;
  text-align: center;
}

.wheel-wrap {
  position: relative;
  width: 320px;
  height: 320px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
}

.wheel {
  position: relative;
  width: 280px;
  height: 280px;
}

.wheel-face {
  position: absolute;
  inset: 0;
  border-radius: 50%;
  border: 6px solid #d4a017;
  background: conic-gradient(
        from -22.5deg,
      #1e4b9e 0deg 45deg,
      #163a7d 45deg 90deg,
      #1e4b9e 90deg 135deg,
      #163a7d 135deg 180deg,
      #1e4b9e 180deg 225deg,
      #163a7d 225deg 270deg,
      #1e4b9e 270deg 315deg,
      #163a7d 315deg 360deg
  );
  box-shadow: 0 0 0 6px rgba(212, 160, 23, 0.35), 0 10px 40px rgba(0, 0, 0, 0.6);
}

.wheel-number {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 0;
  height: 0;
  transform-origin: 0 0;
}

.wheel-number .num {
  position: absolute;
  left: -22px;
  top: -12px;
  width: 44px;
  text-align: center;
  font-size: 14px;
  font-weight: 800;
  color: #ffd25e;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.6);
}

.wheel-pointer {
  position: absolute;
  top: -10px;
  left: 50%;
  transform: translateX(-50%);
  width: 0;
  height: 0;
  border-left: 10px solid transparent;
  border-right: 10px solid transparent;
  border-top: 16px solid #ffd25e;
  z-index: 5;
  filter: drop-shadow(0 2px 3px rgba(0, 0, 0, 0.5));
}

.go-btn {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 62px;
  height: 62px;
  border-radius: 50%;
  background: radial-gradient(circle at 30% 30%, #ffe08a, #d4a017);
  color: #4a3000;
  font-size: 20px;
  font-weight: 900;
  display: grid;
  place-items: center;
  cursor: pointer;
  z-index: 4;
  box-shadow: 0 0 0 4px rgba(212, 160, 23, 0.4), 0 4px 12px rgba(0, 0, 0, 0.5);
}

.go-btn.disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.deco {
  position: absolute;
  font-size: 34px;
  filter: drop-shadow(0 4px 6px rgba(0, 0, 0, 0.5));
  z-index: 1;
}
.deco.chest { left: 0; bottom: 10px; }
.deco.coin { right: 10px; top: 20px; font-size: 26px; }
.deco.gift { right: -6px; bottom: 20px; }

.spins-pill {
  display: inline-block;
  margin-top: 6px;
  padding: 10px 26px;
  border-radius: 22px;
  background: rgba(12, 24, 46, 0.85);
  border: 1px solid rgba(70, 110, 190, 0.35);
  color: #cdd8ee;
  font-size: 14px;
}
.spins-pill b {
  color: #2fd0e6;
  font-size: 16px;
  margin-left: 4px;
}

/* ---- 邀请区 ---- */
.invite-card {
  margin-top: 18px;
  padding: 16px;
  border: 1px solid rgba(70, 110, 190, 0.3);
  border-radius: 14px;
  background: rgba(10, 20, 40, 0.7);
}

.invite-title {
  margin: 0 0 14px;
  text-align: center;
  font-size: 16px;
  font-weight: 700;
  color: #eef3ff;
}

.tabs {
  display: flex;
  gap: 10px;
  margin-bottom: 14px;
}

.tab {
  flex: 1;
  height: 40px;
  border: 0;
  border-radius: 10px;
  background: rgba(20, 35, 65, 0.6);
  color: #9fb0cc;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
}

.tab.active {
  background: linear-gradient(135deg, #2fd0e6, #17a2c4);
  color: #04222b;
}

.record-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.scroll-wrap {
  height: 310px;
  overflow: hidden;
  position: relative;
  mask-image: linear-gradient(180deg, transparent 0, #000 20px, #000 calc(100% - 20px), transparent 100%);
  -webkit-mask-image: linear-gradient(180deg, transparent 0, #000 20px, #000 calc(100% - 20px), transparent 100%);
}

.scroll-inner {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.scroll-inner.scrolling {
  animation: marquee 20s linear infinite;
}

.scroll-inner.scrolling:hover {
  animation-play-state: paused;
}

@keyframes marquee {
  0% { transform: translateY(0); }
  100% { transform: translateY(-50%); }
}

.record-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 14px;
  border-radius: 10px;
  background: rgba(12, 24, 46, 0.72);
  border: 1px solid rgba(70, 110, 190, 0.25);
}

.record-label {
  font-size: 12px;
  color: #9fb0cc;
  margin-bottom: 4px;
}

.record-phone {
  font-size: 14px;
  font-weight: 600;
  color: #e6edfb;
}

.record-amount {
  font-size: 16px;
  font-weight: 800;
  color: #2fd0e6;
}

.empty {
  padding: 24px 0;
  text-align: center;
  color: #6b7a99;
  font-size: 13px;
}

/* ---- 规则 ---- */
.rules-card {
  margin-top: 18px;
  padding: 16px;
  border: 1px solid rgba(70, 110, 190, 0.3);
  border-radius: 14px;
  background: rgba(10, 20, 40, 0.7);
}

.rules-title {
  margin: 0 0 12px;
  font-size: 15px;
  font-weight: 700;
  color: #eef3ff;
}

.rules-list {
  margin: 0;
  padding: 0;
  list-style: none;
}

.rules-list li {
  position: relative;
  padding-left: 16px;
  margin-bottom: 10px;
  font-size: 12px;
  line-height: 1.6;
  color: #9fb0cc;
}

.rules-list li::before {
  content: "";
  position: absolute;
  left: 0;
  top: 7px;
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #2fd0e6;
}
</style>
